module.exports = __webpack_public_path__ + "media/images/blog-list-pic3-6ffcb48840edba1955ffd10ddef92a3b.png";